/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_CopiedInputs */

const th_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกลิงก์แล้ว`)
};

const en_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied.`)
};

const ja_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピーしました。`)
};

const zh_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已复制。`)
};

const es_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace copiado.`)
};

const pt_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiado.`)
};

const id_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan disalin.`)
};

const fr_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien copié.`)
};

const tl_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakopya ang link.`)
};

const vi_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã chép liên kết.`)
};

const ko_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크를 복사했습니다.`)
};

const de_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert.`)
};

const ru_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка скопирована.`)
};

const tr_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı kopyalandı.`)
};

const it_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiato.`)
};

const pl_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link skopiowany.`)
};

const uk_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посилання скопійовано.`)
};

const hi_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक कॉपी हो गया।`)
};

const ar_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نُسخ الرابط.`)
};

const ms_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautan disalin.`)
};

const bn_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিঙ্ক কপি হয়েছে।`)
};

const zh_tw2_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製連結。`)
};

const zh_hk2_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製連結。`)
};

const ur_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنک نقل ہو گیا۔`)
};

const fa_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیوند رونوشت شد.`)
};

const sw_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiungo kimenakiliwa.`)
};

const nl_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link gekopieerd.`)
};

/**
* | output |
* | --- |
* | "Link copied." |
*
* @param {Share_CopiedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const share_copied = /** @type {((inputs?: Share_CopiedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_CopiedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_share_copied(inputs)
	if (locale === "ja") return ja_share_copied(inputs)
	if (locale === "zh") return zh_share_copied(inputs)
	if (locale === "es") return es_share_copied(inputs)
	if (locale === "pt") return pt_share_copied(inputs)
	if (locale === "id") return id_share_copied(inputs)
	if (locale === "fr") return fr_share_copied(inputs)
	if (locale === "tl") return tl_share_copied(inputs)
	if (locale === "vi") return vi_share_copied(inputs)
	if (locale === "ko") return ko_share_copied(inputs)
	if (locale === "de") return de_share_copied(inputs)
	if (locale === "ru") return ru_share_copied(inputs)
	if (locale === "tr") return tr_share_copied(inputs)
	if (locale === "it") return it_share_copied(inputs)
	if (locale === "pl") return pl_share_copied(inputs)
	if (locale === "uk") return uk_share_copied(inputs)
	if (locale === "hi") return hi_share_copied(inputs)
	if (locale === "ar") return ar_share_copied(inputs)
	if (locale === "ms") return ms_share_copied(inputs)
	if (locale === "bn") return bn_share_copied(inputs)
	if (locale === "zh-TW") return zh_tw2_share_copied(inputs)
	if (locale === "zh-HK") return zh_hk2_share_copied(inputs)
	if (locale === "ur") return ur_share_copied(inputs)
	if (locale === "fa") return fa_share_copied(inputs)
	if (locale === "sw") return sw_share_copied(inputs)
	if (locale === "nl") return nl_share_copied(inputs)
	return en_share_copied(inputs)
});